export default (text) => text
  .toString()
  .normalize('NFKD')
  .toLowerCase()
  .trim()
  .replace(/[\s|\-]+/g, '_')
  .replace(/[^\w\_]+/g, '')
  .replace(/\_\_+/g, '_');
